import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';

const ParameterJSONEditorManager = ({parameterContent, setParameterContent, selectedParameter}) => {
  const handleEditorChange = (payload) => {
    if (payload.error) {
      console.error("Error in JSON editor:", payload.error);
      return;
    }

    setParameterContent(prevAllData => ({
      ...prevAllData, 
      
      [selectedParameter]: payload.jsObject 
    }));
  };

  return (
    <div>
      <div style={{ marginTop: '20px' }}>
        <JSONInput
          key={selectedParameter}
          className="w-100"
          height="calc(100vh - 100px)"
          placeholder={parameterContent[selectedParameter]}
          onChange={handleEditorChange}
          locale={locale}
        />
      </div>
    </div>
  )
}

export default ParameterJSONEditorManager;
